export default "__VITE_ASSET__Mn0SZV$I__"